export enum CorporateBusinessType {
  SoleProprietor = 1,
  LLP = 2,
  SdnBhd = 3,
  Other = 4,
  UnlistedBerhad = 5,
  Berhad = 6,
  LegalArrangement = 7,
}
